// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"5895":"e39590bd","8967":"e0144a3f"}[chunkId] + ".chunk.css");